import { http } from "@/lib/http";

/**
 * Registers a single Apple Sign-In redemption link into the unredeemed pool.
 * Mirrors Vue2's ManageAppleLinks.vue -> POST /users/registerCodes.
 * Note: the backend only persists `link` (isRedeemed: false); `code` is sent
 * for fidelity with Vue2 but is not stored server-side.
 */
export function registerAppleLink({ code, link }) {
  return http
    .post("/users/registerCodes", { code, link })
    .then((res) => res.data);
}
